import LoadingImg from '@/assets/icons/loading-button.svg';
import {
  cancelUpcomingToken,
  getVotedOfUpcomingToken,
} from '@/utils/apiRequest/upcoming';
import { useWallet } from '@solana/wallet-adapter-react';
import base58 from 'bs58';
import { useEffect, useState } from 'react';
import Countdown from '../countdown/Countdown';
import { ArrowRightIcon, CheckIcon } from '../icons';
import { errorAlert, successAlert } from '../others/ToastGroup';
import { STEP_TOKEN_CREATION, TIME_TO_LAUNCH } from './config';
import ConfirmCancelModal from './ConfirmCancel';
import { ALL_CONFIGS } from '@/config';

const WaitingForUpcomingToken = ({ coin, setStepCreate }) => {
  const [voteData, setVoteData] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);
  const wallet = useWallet();
  const [showConfirmCancel, setShowConfirmCancel] = useState<boolean>(false);
  // const coin = FAKE_UPCOMING_TOKEN;
  const [isEndCountdown, setIsEndCountdown] = useState(false);

  const startDate = new Date(coin?.date || Date.now());

  useEffect(() => {
    if (!coin) {
      return;
    }

    (async () => {
      try {
        const voteData = await getVotedOfUpcomingToken(coin._id);
        if (voteData) {
          setVoteData(voteData);
        }
      } catch (error) {
        console.log('error get Vote', error);
      }
    })();
  }, [coin]);

  const signCancelToken = async () => {
    try {
      setShowConfirmCancel(false);
      setIsLoading(true);
      const reasonCancel = 'Confirm to cancel launch this upcoming token!';
      const msg = new TextEncoder().encode(`${reasonCancel}`);

      const sig = await wallet.signMessage?.(msg);
      const res = base58.encode(sig as Uint8Array);

      const confirmCancel = await cancelUpcomingToken({
        coinId: coin?._id,
        signature: res,
        wallet: wallet.publicKey?.toBase58(),
        reason: reasonCancel,
      });

      if (confirmCancel) {
        successAlert('Token Canceled!');
        setStepCreate(STEP_TOKEN_CREATION[0]);
        // setShowConfirmCancel(false);
      } else {
        errorAlert('Cancel failed.');
      }
    } catch (error) {
      errorAlert('Cancel failed.');
      console.log('error', error);
    } finally {
      setIsLoading(false);
    }
  };

  const isUpVotePass = voteData?.like >= voteData?.dislike;

  return (
    <div className="w-full flex flex-col gap-6">
      <Countdown
        coin={{ date: startDate }}
        endTime={Math.floor(
          (startDate.getTime() + ALL_CONFIGS.TIME_TO_LAUNCH_UPCOMING_TOKEN) /
            1000,
        )}
        text="The pre-launch phase will end in"
        onEnd={() => {
          setIsEndCountdown(true);
        }}
        showDay
      />

      <div>
        <span className="text-[#9192A0] font-medium">Your Token</span>
        <div className="mt-4">
          <a
            href={`/upcoming/${coin?._id}`}
            target="_blank"
            className="hover:brightness-150 ease-in transition-all"
          >
            <div className="p-5 bg-[#1A1C28] rounded-lg flex justify-between items-center">
              <div className="flex items-center">
                <img
                  src={coin?.metadata?.image || ''}
                  alt="upcoming_img_coin"
                  className="w-6 h-6 rounded-full mr-2 md:mr-3"
                />
                <div className="text-[#E8E9EE] text-[14px] font-medium">
                  {coin?.name}&nbsp;
                  <span className="uppercase">({coin?.ticker})</span>
                </div>
              </div>

              <div className="flex  text-[#9192A0] text-[14px] font-medium cursor-pointer">
                <span>View on Upcoming</span>
                <ArrowRightIcon />
              </div>
            </div>
          </a>
        </div>
      </div>
      <div>
        <span className="text-[#9192A0] font-medium">
          To-Do List for launch
        </span>
        <div className="mt-4 flex flex-col gap-1">
          <a
            href={
              coin?.metadata?.agentClanId
                ? `https://mesh.distilled.ai/clan/${coin.metadata?.agentClanId}`
                : `https://mesh.distilled.ai/invite/${coin.metadata?.agentId}`
            }
            target="_blank"
            className="hover:brightness-150 ease-in transition-all"
          >
            <div className="p-5 bg-[#1A1C28] rounded-lg flex justify-between items-center">
              <div className="flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <rect width="24" height="24" rx="12" fill="white" />
                  <path
                    d="M10.5353 4.125C11.092 4.125 11.4094 4.6794 11.4094 5.23616V8.6484H10.7046C10.5675 8.30957 10.3169 8.02895 9.99558 7.85465C9.67431 7.68035 9.30242 7.62321 8.94365 7.69303C8.58487 7.76284 8.26154 7.95527 8.02908 8.23733C7.79662 8.51939 7.6695 8.87352 7.6695 9.23902C7.6695 9.60453 7.79662 9.95866 8.02908 10.2407C8.26154 10.5228 8.58487 10.7152 8.94365 10.785C9.30242 10.8548 9.67431 10.7977 9.99558 10.6234C10.3169 10.4491 10.5675 10.1685 10.7046 9.82965H11.4094V18.4118C11.4094 18.8812 11.2109 19.3482 10.7928 19.5616C10.4136 19.7602 9.9923 19.8649 9.56426 19.8671C8.37514 19.8671 7.49078 19.2655 6.92141 18.5536C6.5278 18.0618 6.25293 17.486 6.11816 16.8707C5.75044 16.7621 5.40986 16.5769 5.11883 16.3273C4.5597 15.8461 4.125 15.0744 4.125 13.9372C4.125 13.3427 4.16753 12.8245 4.27463 12.389H7.59C8.12393 12.389 8.5665 12.7828 8.64131 13.2954C8.3038 13.4351 8.02532 13.6877 7.85351 14.01C7.68171 14.3323 7.62728 14.7043 7.69953 15.0624C7.77178 15.4204 7.96621 15.7422 8.24957 15.9727C8.53292 16.2031 8.88757 16.328 9.25281 16.3258C9.61806 16.3236 9.97119 16.1945 10.2518 15.9607C10.5323 15.7269 10.7229 15.4028 10.7909 15.0439C10.8589 14.685 10.8 14.3137 10.6244 13.9934C10.4487 13.6732 10.1672 13.4239 9.82807 13.2883C9.78671 12.723 9.53296 12.1943 9.1178 11.8084C8.70265 11.4224 8.15684 11.2079 7.59 11.2078H4.944C5.06169 11.11 5.19301 11.0299 5.33381 10.9699C5.25338 10.6804 5.20634 10.3827 5.19364 10.0824C5.16765 9.50362 5.25427 8.90119 5.42595 8.3649C5.59605 7.83727 5.86538 7.32304 6.24338 6.96787C6.47987 6.73596 6.78055 6.58041 7.10647 6.52136C7.26319 5.85986 7.66245 5.31334 8.17196 4.91722C8.82638 4.40692 9.68396 4.125 10.5345 4.125M12.5906 15.9328H13.89C14.4852 15.9328 15.0561 15.6963 15.477 15.2754C15.8979 14.8545 16.1344 14.2836 16.1344 13.6884V12.2748C16.4732 12.1378 16.7538 11.8871 16.9281 11.5659C17.1024 11.2446 17.1596 10.8727 17.0897 10.5139C17.0199 10.1551 16.8275 9.83182 16.5454 9.59936C16.2634 9.3669 15.9093 9.23977 15.5438 9.23977C15.1782 9.23977 14.8241 9.3669 14.5421 9.59936C14.26 9.83182 14.0676 10.1551 13.9978 10.5139C13.9279 10.8727 13.9851 11.2446 14.1594 11.5659C14.3337 11.8871 14.6143 12.1378 14.9531 12.2748V13.6884C14.9531 13.9704 14.8411 14.2408 14.6417 14.4401C14.4424 14.6395 14.172 14.7515 13.89 14.7515H12.5906V5.23616C12.5906 4.6794 12.908 4.125 13.4648 4.125C14.3168 4.125 15.1736 4.40692 15.828 4.91722C16.3376 5.31334 16.7368 5.86065 16.8935 6.52136C17.2243 6.57649 17.5188 6.74501 17.7566 6.96787C18.1346 7.32304 18.4039 7.83649 18.574 8.3649C18.7457 8.90119 18.8323 9.50362 18.8064 10.0824C18.793 10.3785 18.7497 10.6809 18.6662 10.9699L18.7182 10.9936C19.0095 11.1306 19.2458 11.3456 19.4222 11.6314C19.7569 12.1709 19.875 12.9474 19.875 13.9372C19.875 15.0752 19.4403 15.8477 18.8812 16.3273C18.5899 16.577 18.2491 16.7622 17.8811 16.8707C17.7465 17.4859 17.4719 18.0618 17.0786 18.5536C16.5092 19.2655 15.6249 19.8671 14.4349 19.8671C14.007 19.8652 13.5857 19.7607 13.2064 19.5624C12.7891 19.3482 12.5906 18.8812 12.5906 18.4118V15.9328ZM8.85 9.23902C8.85 9.1346 8.89148 9.03444 8.96533 8.9606C9.03917 8.88676 9.13932 8.84527 9.24375 8.84527C9.34818 8.84527 9.44833 8.88676 9.52217 8.9606C9.59602 9.03444 9.6375 9.1346 9.6375 9.23902C9.6375 9.34345 9.59602 9.44361 9.52217 9.51745C9.44833 9.59129 9.34818 9.63277 9.24375 9.63277C9.13932 9.63277 9.03917 9.59129 8.96533 9.51745C8.89148 9.44361 8.85 9.34345 8.85 9.23902ZM9.24375 14.3578C9.13932 14.3578 9.03917 14.3993 8.96533 14.4731C8.89148 14.5469 8.85 14.6471 8.85 14.7515C8.85 14.856 8.89148 14.9561 8.96533 15.0299C9.03917 15.1038 9.13932 15.1453 9.24375 15.1453C9.34818 15.1453 9.44833 15.1038 9.52217 15.0299C9.59602 14.9561 9.6375 14.856 9.6375 14.7515C9.6375 14.6471 9.59602 14.5469 9.52217 14.4731C9.44833 14.3993 9.34818 14.3578 9.24375 14.3578ZM15.15 10.814C15.15 10.9185 15.1915 11.0186 15.2653 11.0924C15.3392 11.1663 15.4393 11.2078 15.5438 11.2078C15.6482 11.2078 15.7483 11.1663 15.8222 11.0924C15.896 11.0186 15.9375 10.9185 15.9375 10.814C15.9375 10.7096 15.896 10.6094 15.8222 10.5356C15.7483 10.4618 15.6482 10.4203 15.5438 10.4203C15.4393 10.4203 15.3392 10.4618 15.2653 10.5356C15.1915 10.6094 15.15 10.7096 15.15 10.814Z"
                    fill="#0A0D17"
                  />
                </svg>
                <div className="text-[#E8E9EE] text-[14px] font-medium ml-2 md:ml-3">
                  Update AI Agent details on Mesh App
                </div>
              </div>

              <div className="flex  text-[#9192A0] text-[14px] font-medium cursor-pointer">
                <CheckIcon></CheckIcon>
              </div>
            </div>
          </a>
          <a
            href={`/upcoming/${coin?._id}`}
            target="_blank"
            className="hover:brightness-150 ease-in transition-all"
          >
            <div className="p-5 bg-[#1A1C28] rounded-lg flex justify-between items-center">
              <div className="flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <rect width="24" height="24" rx="12" fill="#E4775D" />
                  <path
                    d="M15.5001 14.2382C16.3494 14.6648 17.0776 15.3495 17.609 16.2056C17.7143 16.3752 17.7669 16.4599 17.7851 16.5773C17.8221 16.8159 17.659 17.1091 17.4368 17.2035C17.3274 17.25 17.2045 17.25 16.9585 17.25M14.3335 11.7271C15.1978 11.2976 15.7918 10.4057 15.7918 9.375C15.7918 8.34433 15.1978 7.4524 14.3335 7.02286M13.1668 9.375C13.1668 10.8247 11.9916 12 10.5418 12C9.09207 12 7.91682 10.8247 7.91682 9.375C7.91682 7.92525 9.09207 6.75 10.5418 6.75C11.9916 6.75 13.1668 7.92525 13.1668 9.375ZM6.49303 16.0474C7.42305 14.651 8.89062 13.75 10.5418 13.75C12.193 13.75 13.6606 14.651 14.5906 16.0474C14.7943 16.3533 14.8962 16.5062 14.8845 16.7016C14.8753 16.8538 14.7756 17.04 14.6541 17.1319C14.4979 17.25 14.2832 17.25 13.8538 17.25H7.22986C6.80042 17.25 6.58569 17.25 6.42957 17.1319C6.30801 17.04 6.20828 16.8538 6.19915 16.7016C6.18742 16.5062 6.28929 16.3533 6.49303 16.0474Z"
                    stroke="black"
                    strokeWidth="1.3125"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <div className="text-[#E8E9EE] text-[14px] font-medium ml-2 md:ml-3">
                  Community vote
                </div>
              </div>

              <div className="flex  text-[#9192A0] text-[14px] font-medium cursor-pointer">
                <ArrowRightIcon />
              </div>
            </div>
          </a>
          <a
            href={`/upcoming/${coin?._id}`}
            target="_blank"
            className="hover:brightness-150 ease-in transition-all"
          >
            <div className="p-5 bg-[#1A1C28] rounded-lg flex justify-between items-center">
              <div className="flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <rect width="24" height="24" rx="12" fill="#E4775D" />
                  <path
                    d="M15.5001 14.2382C16.3494 14.6648 17.0776 15.3495 17.609 16.2056C17.7143 16.3752 17.7669 16.4599 17.7851 16.5773C17.8221 16.8159 17.659 17.1091 17.4368 17.2035C17.3274 17.25 17.2045 17.25 16.9585 17.25M14.3335 11.7271C15.1978 11.2976 15.7918 10.4057 15.7918 9.375C15.7918 8.34433 15.1978 7.4524 14.3335 7.02286M13.1668 9.375C13.1668 10.8247 11.9916 12 10.5418 12C9.09207 12 7.91682 10.8247 7.91682 9.375C7.91682 7.92525 9.09207 6.75 10.5418 6.75C11.9916 6.75 13.1668 7.92525 13.1668 9.375ZM6.49303 16.0474C7.42305 14.651 8.89062 13.75 10.5418 13.75C12.193 13.75 13.6606 14.651 14.5906 16.0474C14.7943 16.3533 14.8962 16.5062 14.8845 16.7016C14.8753 16.8538 14.7756 17.04 14.6541 17.1319C14.4979 17.25 14.2832 17.25 13.8538 17.25H7.22986C6.80042 17.25 6.58569 17.25 6.42957 17.1319C6.30801 17.04 6.20828 16.8538 6.19915 16.7016C6.18742 16.5062 6.28929 16.3533 6.49303 16.0474Z"
                    stroke="black"
                    strokeWidth="1.3125"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <div className="text-[#E8E9EE] text-[14px] font-medium ml-2 md:ml-3">
                  Proposal plan for utilites
                </div>
              </div>

              <div className="flex  text-[#9192A0] text-[14px] font-medium cursor-pointer"></div>
            </div>
          </a>
        </div>
      </div>
      <button
        disabled={!isEndCountdown || !isUpVotePass}
        onClick={() => {
          setStepCreate(STEP_TOKEN_CREATION[2]);
        }}
        className="disabled:opacity-75 disabled:cursor-not-allowed uppercase p-1 rounded border-[2px] border-solid border-[rgba(255,255,255,0.25)] cursor-pointer hover:border-[rgba(255,255,255)] transition-all ease-in duration-150"
      >
        <div className="uppercase rounded bg-white px-6 py-2 text-[#080A14] flex items-center justify-center w-full">
          NEXT
        </div>
      </button>

      <button
        disabled={!wallet.publicKey || isLoading}
        onClick={() => setShowConfirmCancel(true)}
        className="flex items-center justify-center disabled:opacity-75 disabled:cursor-not-allowed uppercase p-3 rounded border-[2px] border-solid border-[rgba(255,255,255,0.25)] cursor-pointer hover:border-[rgba(255,255,255)] transition-all ease-in duration-150"
      >
        {isLoading && <img src={LoadingImg} />}&nbsp;Cancel
      </button>

      <ConfirmCancelModal
        title="Confirm Cancel Creating Token!"
        isOpen={showConfirmCancel}
        coin={{
          name: coin?.name,
          symbol: coin?.ticker,
          uri: coin?.metadata?.image,
          token: '',
        }}
        closeModal={() => setShowConfirmCancel(false)}
        onConfirm={async () => {
          signCancelToken();
        }}
      />
    </div>
  );
};

export default WaitingForUpcomingToken;
